export const GET_APPOINTMENT_DETAILS = "/doctor/get-appointment-details-by-id";
export const UPDATE_PURPOSE_OF_CONSULTATION =
  "/doctor/edit-purpose-of-consultation";
export const GET_VERIFICATION_REQUEST = "/abha/v1/verification/request";
export const GET_OR_SEND_OTP = "/abha/v1/verification/status";
export const VERIFY_OTP = "/abha/v1/verification/confirm-otp";
export const UPDATE_DEMOGRAPHIC_DETAILS = "/abha/v1/update-demographic-details";
export const UPDATE_PATIENT_DETAILS = "/doctor/v1/update-appointment-details";
